(() => {
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];
  const root = window.TT?.root || '/';
  const cartPath = window.TT?.cart || `${root}cart`;
  const drawer = $('#TTDrawer');
  let previousFocus;
  const money = (value, currency) => (value / 100).toLocaleString(document.documentElement.lang || undefined, {style: 'currency', currency});
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character]));
  async function request(url, options) {
    const response = await fetch(url, {...options, headers: {'Accept': 'application/json', ...options?.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  async function refreshCart() {
    const body = $('[data-cart-body]');
    body.textContent = 'Loading your cart…';
    try {
      const cart = await request(`${cartPath}.js`);
      $$('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
      body.innerHTML = cart.items.length ? cart.items.map(item => `<div class="draweritem">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="70" height="70">` : '<div></div>'}<div><a href="${escape(item.url)}"><b>${escape(item.product_title)}</b></a>${item.variant_title ? `<small>${escape(item.variant_title)}</small>` : ''}<small>Quantity: ${item.quantity}</small><small>${escape(money(item.final_line_price, cart.currency))}</small></div></div>`).join('') + `<div class="drawertotal"><span>Subtotal</span><b>${escape(money(cart.total_price, cart.currency))}</b></div><a class="btn green" href="${escape(cartPath)}">View Cart</a><form action="${escape(cartPath)}" method="post"><button class="checkout" type="submit" name="checkout">Checkout</button></form>` : '<p>Your cart is empty.</p>';
    } catch (error) {
      body.innerHTML = `<p role="alert">${escape(error.message)}</p><a class="btn green" href="${escape(cartPath)}">View Cart</a>`;
    }
  }
  function openDrawer() {
    if (!drawer) return;
    previousFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.focus();
    refreshCart();
  }
  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    drawer?.setAttribute('aria-hidden', 'true');
    previousFocus?.focus();
  }
  function selectTab(tab) {
    const section = tab.closest('[data-tabs]');
    $$('[role="tab"]', section).forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-drawer-open]')) {event.preventDefault(); openDrawer();}
    if (event.target.closest('[data-drawer-close]')) closeDrawer();
    const tab = event.target.closest('[role="tab"]');
    if (tab) selectTab(tab);
    const quantityButton = event.target.closest('[data-plus], [data-minus]');
    if (quantityButton) {
      const input = $('input', quantityButton.parentElement);
      if (quantityButton.hasAttribute('data-plus')) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
  });
  document.addEventListener('keydown', event => {
    if (document.body.classList.contains('drawer-open')) {
      if (event.key === 'Escape') closeDrawer();
      if (event.key === 'Tab') {
        const elements = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]', drawer);
        const first = elements[0], last = elements.at(-1);
        if (!first) {event.preventDefault(); drawer.focus();}
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {event.preventDefault(); last.focus();}
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === drawer)) {event.preventDefault(); first.focus();}
      }
    }
    const tab = event.target.closest('[role="tab"]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const tabs = $$('[role="tab"]', tab.closest('[data-tabs]'));
      let index = tabs.indexOf(tab);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectTab(tabs[index]); tabs[index].focus();
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const section = event.target.closest('[data-product-section]');
    const variants = JSON.parse($('[data-variants]', section).textContent);
    const variant = variants.find(value => String(value.id) === event.target.value);
    if (!variant) return;
    $('[data-product-price]', section).textContent = variant.price;
    const compare = $('[data-product-compare]', section);
    compare.textContent = variant.compare; compare.hidden = !variant.on_sale;
    const button = $('[data-add-button]', section);
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to Cart' : 'Sold out';
    const quantity = $('[name="quantity"]', section);
    quantity.min = variant.min; quantity.step = variant.step;
    if (variant.max !== null) quantity.max = variant.max; else quantity.removeAttribute('max');
    quantity.value = variant.min;
    const error = $('[data-add-error]', section); error.hidden = true;
    const image = $('[data-main-image]', section);
    if (variant.image && image) {image.src = variant.image; image.alt = variant.alt; section.dispatchEvent(new CustomEvent('tt:variant-image', {detail: {id: variant.image_id, url: variant.image, alt: variant.alt}}));}
    const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.ajax-add')) return;
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    if (button?.disabled) return;
    const error = $('[data-add-error]', form);
    if (error) error.hidden = true;
    const formData = new FormData(form);
    const originalText = button?.textContent;
    if (button) {button.disabled = true; button.textContent = 'Adding…';}
    try {
      await request(`${window.TT?.add || `${root}cart/add`}.js`, {method: 'POST', body: formData});
      openDrawer();
    } catch (failure) {
      if (error) {error.textContent = failure.message; error.hidden = false;}
    } finally {
      if (button) {
        const section = form.closest('[data-product-section]');
        const selector = section && $('[data-variant-select]', section);
        const variant = selector && JSON.parse($('[data-variants]', section).textContent).find(value => String(value.id) === selector.value);
        button.disabled = variant ? !variant.available : false;
        button.textContent = variant ? (variant.available ? 'Add to Cart' : 'Sold out') : originalText;
      }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.id !== 'CartPageForm') return;
    event.preventDefault();
    if (form.dataset.pending) return;
    form.dataset.pending = 'true';
    const checkout = event.submitter?.name === 'checkout';
    const error = $('[data-cart-error]', form); error.hidden = true;
    const data = new FormData(form); data.delete('checkout'); data.delete('update');
    const buttons = $$('button[type="submit"]', form); buttons.forEach(button => button.disabled = true);
    try {
      const cart = await request(`${root}cart/update.js`, {method: 'POST', body: data});
      if (checkout && cart.item_count > 0) location.assign(`${root}checkout`); else location.reload();
    } catch (failure) {
      error.textContent = failure.message; error.hidden = false;
      buttons.forEach(button => button.disabled = false); delete form.dataset.pending;
    }
  });
})();
